import { ColumnDef } from '@tanstack/react-table'
import { GetGameTypeTableData } from '@/modules/game/type'
import { IsActiveGameType } from './components/IsActiveGameType'

export const columns: ColumnDef<GetGameTypeTableData>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
		cell: ({ row }) => row.original.order || '-',
	},
	{
		accessorKey: 'name',
		header: 'ชื่อประเภทเกม',
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveGameType row={row.original} />,
	},
]
